import { useState, useEffect } from 'react'
import { Button, Flex, Text, TextField, Spinner } from '@radix-ui/themes'
import api from '../../../api'
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { updateStudents } from '../../../redux/slices/guardianSlice'
import { updateAccountDetails } from '../../../redux/slices/accountSlice';

const GenerateGuardianCode = ({ onComplete }) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const account = useSelector(state => state.account);

    useEffect(() => {
        console.log('guardian::', account.details)
    }, [account])

    const generateCode = async (guardianId) => {
        try {
            setLoading(true)
            // move this to a service object
            const response = await api.post(`guardians/${guardianId}/generate-code`)
            const data = response.data
            console.log('generating guardian code::', data.guardian_code);
            onComplete(data.guardian_code)

            dispatch(updateAccountDetails({ ...account.details, guardian_code: data.guardian_code }))

            toast.success(`Code generated successfully, CODE: ${data.guardian_code}`, {
                position: "bottom-right"
            })

        } catch (err) {
            console.log('error generating code::', err.response.data.error)
            //An error occured while verifying, try again
            toast.error(err.response.data.error, {
                position: "bottom-right",
            });
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className='w-full'>

            <Flex direction="column" gap="3">

                {account.details?.guardian_code &&
                    <Text size="5" mb="4">Guardian Code:: {account.details.guardian_code}</Text>
                }

                <Button onClick={() => generateCode(account.details.id)} disabled={loading} type="submit" className='cursor-pointer'>
                    {loading ? (
                        <Flex gap="2" align="center">
                            <Spinner size="1" />
                            Loading...
                        </Flex>
                    ) : (
                        'Generate Code'
                    )}
                </Button>


            </Flex>

        </div>
    );
};

export default GenerateGuardianCode;